export interface Entry {
	EntryId: number;
	ShiftId: number;
	AssetId: number | null;
	Shift: string | null;
	Crew: string | null;
	Title: string;
	Content: string;
	CreateTimestamp: Date | null;
	UpdateTimestamp: Date | null;
	LogEntryTypeCode: "M" | "A";
	Author: string | null;
	UpdatedBy: string | null;
	AttachmentCount?: number;
}

export const ENTRY_INITIAL_VALUES: Entry = {
	EntryId: 0,
	ShiftId: 0,
	AssetId: null,
	Title: "",
	Content: "",
	CreateTimestamp: new Date(),
	UpdateTimestamp: new Date(),
	LogEntryTypeCode: "M",
	Shift: null,
	Crew: null,
	Author: null,
	UpdatedBy: null,
	AttachmentCount: 0,
};
